import React, { useState } from "react";
import { Box, Button, IconButton, Modal, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CreateUserModal = (props) => {
    const { openModal, handleCloseModal, lastName, setLastName, firstName, setFirstName, email, setEmail,  handleUserCreate } = props;
    const [errors, setErrors] = useState({});

    const validateForm = () => {
      const newErrors = {};
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!firstName?.trim()) newErrors.firstName = "User name is required";
      if (!email?.trim()) {
        newErrors.email = "Email is required";
      } else if (!emailRegex.test(email)) {
        newErrors.email = "Invalid email";
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };

    const handleCreateUser = () => {
      if (validateForm()) {
        handleUserCreate();
      }
    };
  

    return (
    <Modal open={openModal} onClose={handleCloseModal}>
        <Box style={{padding: '32px 0px !important', borderRadius: '4px', position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", background: "white", boxShadow: 24, p: 4, width: 700}}>
          <IconButton aria-label="close" onClick={handleCloseModal} sx={{position: "absolute", top: 8, right: 8, color: (theme) => theme.palette.grey[500]}}>
            <CloseIcon />
          </IconButton>
          <Typography id="create-user-modal" variant="h6" component="h2" gutterBottom sx={{fontWeight: '600', borderBottom: 1, borderColor: "divider", padding: '20px 32px'}}>
            Create User
          </Typography>
          <Box sx={{padding: '20px 32px 32px 32px', display: 'flex', flexDirection: 'column', gap: '16px'}}>
            <Box>
              <TextField label="First Name" variant="outlined" required fullWidth value={firstName} onChange={(e) => { setFirstName(e.target.value); setErrors((prev) => ({ ...prev, firstName: "" })); }} error={!!errors.firstName} helperText={errors.firstName} sx={{ marginBottom: "16px", "& .MuiInputLabel-asterisk": { color: "red" }}}/>
              <TextField label="Last Name" variant="outlined" fullWidth value={lastName} onChange={(e) => { setLastName(e.target.value); setErrors((prev) => ({ ...prev, lastName: "" })); }} error={!!errors.lastName} helperText={errors.lastName} sx={{ marginBottom: "16px", "& .MuiInputLabel-asterisk": { color: "red" }}}/>
              <TextField label="Email" variant="outlined" required fullWidth value={email} type="email"  onChange={(e) => { setEmail(e.target.value); setErrors((prev) => ({ ...prev, email: "" })); }} error={!!errors.email} helperText={errors.email} sx={{ marginBottom: "16px", "& .MuiInputLabel-asterisk": { color: "red" }}}/>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button variant="contained" onClick={handleCreateUser} sx={{textTransform: 'capitalize', fontWeight: '600'}}>
                Create User
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
  )
}
export default CreateUserModal;